import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { mediaTablet } from '../styles/breakpoints';
import { sharpImageRendering } from '../styles/images';

import Image from './Grafik_PDF-Download.png';
import Image2x from './Grafik_PDF-Download@2x.png';

const Container = styled.div`
  text-align: center;
`;

const ContainerInsideCTA = css`
  overflow: hidden;
  text-align: center;
  padding: 0 10px;
  border-bottom: 2px solid #fff;

  height: 170px;

  ${mediaTablet} {
    height: 120px;
    padding: 0 15px;
  }
`;

const Img = styled.img`
  ${sharpImageRendering}
  max-width: 100%;
`;

const GrafikPDFDownload = ({ insideCTA }) => (
  <Container className={insideCTA ? ContainerInsideCTA : ''}>
    <Img
      src={Image}
      srcSet={`${Image} 1x, ${Image2x} 2x`}
      alt="Grafik PDF Download"
    />
  </Container>
);

GrafikPDFDownload.propTypes = {
  insideCTA: PropTypes.bool,
};

GrafikPDFDownload.defaultProps = {
  insideCTA: false,
};

export default GrafikPDFDownload;



// WEBPACK FOOTER //
// ./src/components/GrafikPDFDownload/GrafikPDFDownload.js